import { render, staticRenderFns } from "./ConfirmMergeDetailsModal.vue?vue&type=template&id=70b9db0b"
import script from "./ConfirmMergeDetailsModal.vue?vue&type=script&lang=js"
export * from "./ConfirmMergeDetailsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports